import React, { useMemo } from 'react';
import { monitoring_center_path, orchards_monitoring_center_path } from 'js-routes/generated/routes';
import { bool, func, string } from 'prop-types';
import { Button, Typography, Space } from 'antd';
import { isOrchard } from 'helpers/userSessionSettings';
import {
  CwoLogo,
  CwoLogoRu,
  SwoLogoSmall,
  OpenMenuIcon,
  CloseMenuIcon,
} from 'components/cwo-icons';

const { Link } = Typography;

const logoUrl = isOrchard ? orchards_monitoring_center_path() : monitoring_center_path();
const logoForCountry = { ru: <CwoLogoRu />, default: <CwoLogo /> };

const LeftPart = ({
  collapsed = true,
  showCwoLogoSmall = false,
  dontShowCwoLogo = false,
  setCollapsed,
  currentCountry,
}) => {
  const logo = useMemo(() => {
    if (showCwoLogoSmall && !dontShowCwoLogo) {
      return <SwoLogoSmall />;
    }

    return logoForCountry[currentCountry] || logoForCountry.default;
  }, [currentCountry, dontShowCwoLogo, showCwoLogoSmall]);

  return (
    <Space className="navigation-top-menu-left-part">
      <Button
        className="navigation-top-menu-left-part__sider-button"
        type="link"
        icon={collapsed ? <OpenMenuIcon /> : <CloseMenuIcon />}
        onClick={() => setCollapsed(!collapsed)}
      />
      <Link className="navigation-top-menu-left-part__logo" href={logoUrl}>
        {!dontShowCwoLogo && logo}
      </Link>
    </Space>
  );
};

LeftPart.propTypes = {
  collapsed: bool,
  showCwoLogoSmall: bool,
  dontShowCwoLogo: bool,
  setCollapsed: func.isRequired,
  currentCountry: string.isRequired,
};

export default LeftPart;
